import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper } from '@mui/material';
import Pagination from 'src/components/BeaconV2Components/Pagination/Pagination';

export interface UrlListTableProps {
  urls: string[];
  validUrls?: string[];
  rowsPerPage?: number;
  onRemoveUrl?: (url: string) => void;
  useValidityColors?: boolean; // when false, render neutral text color
}

const UrlListTable: React.FC<UrlListTableProps> = ({ urls, validUrls = [], rowsPerPage = 5, onRemoveUrl, useValidityColors = true }) => {
  const [page, setPage] = React.useState(1);

  React.useEffect(() => {
    setPage(1);
  }, [urls.length]);
  const totalPages = Math.max(Math.ceil(urls.length / rowsPerPage), 1);
  const onClickNext = () => setPage((p) => Math.min(totalPages, p + 1));
  const onClickPrevious = () => setPage((p) => Math.max(1, p - 1));

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: 4, border: '1px solid #E6ECF2', boxShadow: 'none', overflow: 'hidden' }}>
        <Table size="small" aria-label="product urls table" sx={{ tableLayout: 'fixed', width: '100%', '& td, & th': { borderBottom: '1px solid #EFF2F5' } }}>
          <TableBody>
            {urls
              .slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)
              .map((u) => {
                const isValid = validUrls.includes(u);
                const color = useValidityColors ? (isValid ? '#2B825B' : '#7A271A') : '#031425';
                return (
                  <TableRow key={u} hover>
                    <TableCell sx={{ color, fontSize: 14, py: 1.5, overflow: 'hidden', width: '100%' }} title={u}>
                      <span style={{ display: 'block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u}</span>
                    </TableCell>
                    <TableCell align="right" sx={{ width: 56, py: 1.5 }}>
                      {onRemoveUrl && (
                        <button
                          onClick={() => onRemoveUrl(u)}
                          aria-label={`Remove ${u}`}
                          style={{
                            border: '1px solid #E8E8ED',
                            background: '#F8F9F9',
                            color: '#031425',
                            borderRadius: 9999,
                            padding: '0 10px',
                            lineHeight: '22px',
                            height: 24,
                            cursor: 'pointer',
                            marginRight: 8
                          }}
                        >
                          ×
                        </button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onClickNext={onClickNext}
          onClickPrevious={onClickPrevious}
          shouldUseInfinitePagination
        />
      </div>
    </>
  );
};

export default UrlListTable;


